import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 112px;

  @media(max-width: 499px){
    margin-top: 36px;
  }
`;

export const HeroSection = styled.section`
  text-align: center;
  margin-bottom: -200px;
`;

export const Title = styled.h1`
  font-family: Nexa Bold;
  font-weight: 700;
  font-style: Regular;
  font-size: 108px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  margin: 0px;
  
  @media (max-width: 768px) {
    font-size: 58px;
  }
`;

export const Subtitle = styled.p`
  font-family: Open Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 36px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  margin: 28px 0px;

  @media (max-width: 499px) {
    font-size: 24px;
  }
`;

export const Description = styled.p`
  font-family: Open Sans;
  font-weight: 300;
  font-size: 28px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  width: 70%;
  margin: auto;
  
  @media (max-width: 499px) {
    font-size: 18px;
  }

`

export const CurvedBackground = styled.div`
  background: linear-gradient(to right, #f6921e, #f9a825);
  height: 100px;
  width: 100%;
  clip-path: ellipse(140% 100% at 50% 0%);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 1rem;
  margin-bottom: -50px; /* overlap with image */
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  top: -240px;
  z-index: 4;

  @media (max-width: 768px) {
    margin-top: 140px;
    top: -260px;
  }
`;

export const CTAButton = styled.button`
  background: white;
  color: black;
  font-weight: bold;
  font-size: 36px;
  padding: 16px 30px;
  border-radius: 18px;
  border: none;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.6rem 1.2rem;
  }

  &:hover {
    background: black;
    color: white;
  }
`;


export const ImageSection = styled.div`
  position: relative;
  top: -220px;
  z-index: 5;
  margin: 0 auto;

  @media (max-width: 768px) {
    top: -240px;
  }
`;

export const MainImage = styled.img`
  width: 80vw;
  height: 35vw;
  border-radius: 36px;
  margin: 0 auto;
  display: block;

  @media (max-width: 768px) {
    width: 90vw;
    height: 40vw;
  }
`;